import { useState } from "react";
import "./verifyEmailModal.scss";
import { toast } from "sonner";
import { Icon } from "@/components";
import { useSendEmailVerification } from "@/services/profile/useSendEmailVerification";

interface VerifyEmailProps {
  show: boolean;
  setShow: (value: boolean) => void;
  email: string;
}

const VerifyEmailModal: React.FC<VerifyEmailProps> = ({
  show,
  setShow,
  email,
}) => {
  const [showInput, setShowInput] = useState(false);
  const [inputEmail, setInputEmail] = useState("");

  const userEmail = inputEmail || email;

  const { sendVerificationEmail, sending } = useSendEmailVerification(setShow);

  if (!show) return null;

  const handleEmailVerification = () => {
    if (!userEmail) {
      toast.error("Please enter a valid email address.");
      return;
    }
    sendVerificationEmail(userEmail);
  };

  return (
    <div className="verify-modal-overlay" onClick={() => setShow(false)}>
      <div
        className="verify-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <span onClick={() => setShow(false)} className="verify-close">
          <Icon name="close" />
        </span>
        <div style={{ margin: "20px 0" }}>
          <h3>Please verify your email to gain full access to Pluritongues</h3>
          <p style={{ color: "#808080", padding: "14px 0" }}>
            Confirm your email by clicking the link we sent to{" "}
            <span style={{ color: "black" }}>{email}</span>
          </p>
          <p>
            Wrong email address?{" "}
            <span
              style={{ color: "#169FED", cursor: "pointer" }}
              onClick={() => setShowInput(!showInput)}
            >
              Click here.
            </span>
          </p>
          {showInput && (
            <input
              type="email"
              placeholder="Enter email for verification"
              value={inputEmail}
              onChange={(e) => setInputEmail(e.target.value)}
              className="verify-input"
            />
          )}
        </div>
        <button
          className="send-verify-email-button"
          onClick={handleEmailVerification}
          disabled={sending}
        >
          {sending ? "Loading..." : "Send Verification Email"}
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailModal;
